import { Quote, Star } from "lucide-react";
import { useContent } from "../contexts/ContentContext";

export default function Testimonials() {
  const { content } = useContent();
  const t = content?.testimonials || {};
  if (t.enabled === false) return null;
  const items = t.items || [];

  return (
    <section id="testimonials" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl">
          <div className="overline">{t.eyebrow}</div>
          <h2 className="font-display mt-3 text-3xl lg:text-4xl font-medium tracking-tight">
            {t.heading}
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {items.map((it, i) => (
            <figure
              key={`${it.name}-${i}`}
              data-testid={`testimonial-${i}`}
              className="relative p-7 lg:p-9 rounded-2xl bg-white border border-border hover:border-primary/30 hover:shadow-lg transition-all"
            >
              <Quote className="h-7 w-7 text-primary/20 absolute top-6 right-6" />
              <div className="flex gap-0.5 text-accent">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <blockquote className="mt-4 text-base lg:text-lg leading-relaxed text-foreground">
                &ldquo;{it.text}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-border">
                <div className="font-display text-base font-medium">{it.name}</div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground mt-1">{it.course}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
